module.exports = __webpack_public_path__ + "static/media/tor4.df32c6ba.svg";